import { Card, Button, ButtonGroup, IconButton, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import logo from "../../assest/images/EMFlogo.png";
import MaterialButton from "../../components/MaterialButton";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation, useNavigate } from "react-router-dom";
import BASEURL, { MEDIAURL } from "../Utils/Baseurl";
import axios from "axios";
import { useLoading } from "../../context/loading";
import { fetchCompanyAll } from "../../ApiBaseUrl";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MaterialTypography from "../../components/MaterialTypography";

const SalarySlip = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const locationData = location?.state;
  const [payslip, setPayslip] = useState([]);
  const payslipRefs = useRef([]);
  const [logoBase64, setLogoBase64] = useState(null);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const styles = {
    container: {
      width: "800px",
      margin: "10px auto",
      padding: "20px",
      border: "1px solid #ddd",
      fontFamily: "Roboto, sans-serif",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
      borderRadius: "6px",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "15px",
      borderBottom: "1px solid #ccd1d1",
      paddingBottom: "10px",
    },
    logo: {
      width: "100px",
      height: "60px",
      objectFit: "contain",
    },
    companyInfo: {
      flex: 1,
      textAlign: "center",
    },
    companyName: {
      fontWeight: "600",
      fontSize: "22px",
      color: "#333",
      marginBottom: "3px",
    },
    address: {
      fontSize: "13px",
      color: "#666",
      marginTop: "3px",
    },
    mainslip: {
      textAlign: "center",
      fontSize: "18px",
      fontWeight: "500",
      color: "#444",
      margin: "15px 0",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginBottom: "15px",
    },
    thLeft: {
      border: "1px solid #ccd1d1",
      padding: "8px",
      textAlign: "left",
      fontSize: "13px",
      color: "#555",
      fontWeight: "500",
    },
    thCenter: {
      border: "1px solid #ccd1d1",
      padding: "8px",
      textAlign: "center",
      fontSize: "13px",
      color: "#555",
      fontWeight: "600",
    },
    tdLeft: {
      border: "1px solid #ccd1d1",
      padding: "8px",
      textAlign: "left",
      fontSize: "13px",
      color: "#444",
    },
    tdRight: {
      border: "1px solid #ccd1d1",
      padding: "8px",
      textAlign: "right",
      fontSize: "13px",
      color: "#444",
    },
    grossNetRow: {
      backgroundColor: "#f9f9f9",
    },
  };
  const pdfRef = useRef();
  const downloadPDF = async () => {
    if (locationData) {
      const input = pdfRef.current;
      html2canvas(input, { scale: 2, useCORS: true, allowTaint: true }).then(
        (canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF("p", "mm", "a4");
          const imgWidth = 210;
          const pageHeight = 297;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;
          let position = 0;

          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft > 0) {
            // position = heightLeft - imgHeight;
            position -= pageHeight;
            pdf.addPage();
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }

          pdf.save("salary_slip.pdf");
        }
      );
    } else {
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const pageHeight = 297;

      for (let i = 0; i < payslipRefs.current.length; i++) {
        const element = payslipRefs.current[i];

        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
        });
        const imgData = canvas.toDataURL("image/png");

        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (i > 0) {
          pdf.addPage();
        }

        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      }

      pdf.save("all_payslips.pdf");
    }
  };

  useEffect(() => {
    onSalaryStructureSubmit();
    fetchdata();
  }, []);

  const fetchdata = async () => {
    setCirleLoading(true);
    try {
      const response = await fetchCompanyAll("getCompany", [
        "id",
        "companyName",
        "address",
        "state",
        "country",
        "zipCode",
        "logo",

        "phoneNumber",
        "email",
        "website",
        "gstNumber",
      ]);

      if (response?.getCompany?.length == 1) {
        setLogoBase64(MEDIAURL + "media/" + response?.getCompany[0]?.logo);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCirleLoading(false);
    }
  };

  const onSalaryStructureSubmit = async () => {
    let query;
    if (locationData) {
      query = `
          query GetPayrollsByUserId($userId: Int!, $category: String, $month: Int, $year: Int) { 
            payrollsByUserId(userId: $userId, category: $category, month: $month, year: $year) { 
              id 
              employee { 
                  id 
                  firstName 
                  empid 
                  branch 
                  category 
                  dateOfJoining 
                  employeeType 
                  uanNumber 
                  esicNumber 
                  lastName
                } 
                month 
                year      
                monthDays 
                salaryDays 
                absentDays 
                mealsDays 
                shiftPaiseDays 
                otHours 
                basicAmount 
                daAmount 
                mealsAmountPerDay 
                otAmountPerHour 
                shiftPaisa 
                attendanceAmount 
                busFare 
                esiAmount 
                pfAmount 
                advanceAmount  
                bonusAmount      
                earnedBasic 
                earnedDa 
                lopAmount 
                otAmount 
                shiftPaiseAmount 
                busFare 
                attendanceAllowance 
                mealsAmount 
                grossPay 
                totalAmount 
                netPay 
            } 
          } 
              `;
    } else {
      query = `query GetAllPayrolls($category: String, $month: Int, $year: Int) { 

  allPayrolls(category: $category, month: $month, year: $year) { 

    id 

    employee { 

        id 

        firstName 
        lastName

        empid 

        branch 

        category 

      	dateOfJoining 

      	employeeType 

      	uanNumber 

      	esicNumber 

      } 

      month 

      year 

       

      monthDays 

      salaryDays 

      absentDays 

      mealsDays 

      shiftPaiseDays 

      otHours 

       

      basicAmount 

      daAmount 

      mealsAmountPerDay 

      otAmountPerHour 

      shiftPaisa 

      attendanceAmount 

      busFare 

      esiAmount 

      pfAmount 

      advanceAmount  

      bonusAmount 

       

      earnedBasic 

      earnedDa 

      lopAmount 

      otAmount 

      shiftPaiseAmount 

      busFare 

      attendanceAllowance 

      mealsAmount 

       

      grossPay 

      totalAmount 

      netPay 

  } 

} `;
    }
    const variables = {
      category: locationData?.employee?.category,
      month: locationData?.month,
      year: locationData?.year,
    };
    if (locationData) {
      variables.userId = locationData?.employee?.id;
    }

    setCirleLoading(true);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (locationData) {
        setPayslip(response?.data?.data?.payrollsByUserId?.[0]);
      } else {
        setPayslip(response?.data?.data?.allPayrolls);
      }
    } catch (error) {
      console.error("ResponseError:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        {/* <MaterialBox style={{ display: "flex", justifyContent: "space-between" }}> */}
        <Stack
          direction="row"
          spacing={0}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackIcon />
            </IconButton>
            <MaterialTypography variant="h5" fontWeight="medium">
              Pay Slip
            </MaterialTypography>
          </Stack>
          <ButtonGroup
            variant="outlined"
            aria-label="button group"
            display="flex"
            justifyContent="flex-end"
          >
            <MaterialButton
              sx={{ marginLeft: "15px", marginTop: "15px" }}
              variant="gradient"
              color="dark"
              onClick={downloadPDF}
            >
              Download PDF
            </MaterialButton>
          </ButtonGroup>
        </Stack>

        {/* </MaterialBox> */}
        {locationData ? (
          <div ref={pdfRef} style={styles.container}>
            {/* Header Section */}
            <div style={styles.header}>
              <img
                src={logoBase64 || logo}
                alt="Company Logo"
                style={styles.logo}
              />
              <div style={styles.companyInfo}>
                <div style={styles.companyName}>
                  ELECTROPLATING AND METAL FINISHERS
                </div>
                <div style={styles.address}>
                  K-32, 10TH STREET, AMBATTUR INDUSTRIAL ESTATE, CHENNAI-58
                </div>
              </div>
            </div>
            <div style={styles.bottomLine}></div>
            <div style={styles.mainslip}>Salary Slip</div>

            <table style={styles.table}>
              <tbody>
                <tr>
                  <th style={styles.thLeft} colSpan="2">
                    <div>NAME</div>
                  </th>
                  <td style={styles.tdRight} colSpan="2">
                    {payslip?.employee?.firstName}
                  </td>
                </tr>
                <tr>
                  <th style={styles.thLeft}>BASIC</th>
                  <td style={styles.tdRight}>{payslip?.basicAmount}</td>
                  <th style={styles.thLeft}>UAN NO</th>
                  <td style={styles.tdRight}>{payslip?.employee?.uanNumber}</td>
                </tr>
                <tr>
                  <th style={styles.thLeft}>DA</th>
                  <td style={styles.tdRight}>{payslip?.daAmount}</td>
                  <th style={styles.thLeft}>ESIC NO</th>
                  <td style={styles.tdRight}>
                    {payslip?.employee?.esicNumber}
                  </td>
                </tr>
                <tr>
                  <th style={styles.thLeft}>HRA</th>
                  <td style={styles.tdRight}>{payslip?.attendanceAllowance}</td>
                  <th style={styles.thLeft}>DOJ</th>
                  <td style={styles.tdRight}>
                    {moment(payslip?.employee?.dateOfJoining).format(
                      "DD-MM-YYYY"
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={styles.thLeft}>MONTH</th>
                  <td style={styles.tdRight}>{`${
                    monthNames[(payslip?.month || 1) - 1]
                  },${payslip?.year}`}</td>
                  <th style={styles.thLeft}>NUMBER OF DAYS EMPLOYEE WORKED</th>
                  <td style={styles.tdRight}>{payslip?.salaryDays}</td>
                </tr>
                <tr>
                  <th style={styles.thLeft}>TOTAL COMPANY WORKING DAYS</th>
                  <td style={styles.tdRight}>{payslip?.monthDays}</td>
                  <th style={styles.thLeft}>NUMBER OF DAYS EMPLOYEE ABSENT</th>
                  <td style={styles.tdRight}>{payslip?.absentDays}</td>
                </tr>
              </tbody>
            </table>

            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.thCenter} colSpan="2">
                    EARNINGS
                  </th>
                  <th style={styles.thCenter} colSpan="2">
                    DEDUCTIONS
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={styles.tdLeft}>EARNED BASIC</td>
                  <td style={styles.tdRight}>{payslip?.earnedBasic}</td>
                  <td style={styles.tdLeft}>ESIC</td>
                  <td style={styles.tdRight}>{payslip?.esiAmount}</td>
                </tr>
                <tr>
                  <td style={styles.tdLeft}>EARNED DA</td>
                  <td style={styles.tdRight}>{payslip?.earnedDa}</td>
                  <td style={styles.tdLeft}>PF</td>
                  <td style={styles.tdRight}>{payslip?.pfAmount}</td>
                </tr>
                <tr>
                  <td style={styles.tdLeft}>EARNED HRA</td>
                  <td style={styles.tdRight}>{payslip?.attendanceAllowance}</td>
                  <td style={styles.tdLeft}>ADVANCE</td>
                  <td style={styles.tdRight}>{payslip?.advanceAmount}</td>
                </tr>
                <tr>
                  <td style={styles.tdLeft}>EARNED CONVEYANCE</td>
                  <td style={styles.tdRight}>{payslip?.otAmount}</td>
                  <td style={styles.tdLeft}>MEALS</td>
                  <td style={styles.tdRight}>{payslip?.mealsAmount}</td>
                </tr>
                <tr>
                  <td style={styles.tdLeft}>ADDITIONAL ALLOWANCE</td>
                  <td style={styles.tdRight}>{payslip?.shiftPaiseAmount}</td>
                  <td style={styles.tdLeft}>DEDUCTIONS TOTAL</td>
                  <td style={styles.tdRight}>
                    {+payslip?.esiAmount +
                      +payslip?.pfAmount +
                      +payslip?.advanceAmount +
                      +payslip?.mealsAmount}
                  </td>
                </tr>
                <tr>
                  <td style={styles.tdLeft}>EARNED INCENTIVE</td>
                  <td style={styles.tdRight}>{payslip?.busFare}</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td style={styles.tdLeft}>OVERTIME</td>
                  <td style={styles.tdRight}>{payslip?.otAmount}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <table style={styles.table}>
              <tbody>
                <tr>
                  <th style={styles.thLeft}>GROSS PAY</th>
                  <td style={styles.tdRight}>{payslip?.grossPay}</td>
                  <th style={styles.thLeft}>NET PAY (GROSS - DEDU)</th>
                  <td style={styles.tdRight}>{payslip?.netPay}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          payslip.map((payslips, ind) => {
            return (
              <div
                ref={(el) => (payslipRefs.current[ind] = el)}
                style={styles.container}
                key={ind}
              >
                <div style={styles.header}>
                  <img
                    src={logoBase64 || logo}
                    alt="Company Logo"
                    style={styles.logo}
                  />
                  <div style={styles.companyInfo}>
                    <div style={styles.companyName}>
                      ELECTROPLATING AND METAL FINISHERS
                    </div>
                    <div style={styles.address}>
                      K-32, 10TH STREET, AMBATTUR INDUSTRIAL ESTATE, CHENNAI-58
                    </div>
                  </div>
                </div>
                <div style={styles.bottomLine}></div>
                <div style={styles.mainslip}>Salary Slip</div>

                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <th style={styles.thLeft} colSpan="2">
                        <div>NAME</div>
                      </th>
                      <td style={styles.tdRight} colSpan="2">
                        {payslips?.employee?.firstName +
                          " " +
                          payslips?.employee?.lastName}
                      </td>
                    </tr>
                    <tr>
                      <th style={styles.thLeft}>BASIC</th>
                      <td style={styles.tdRight}>{payslips?.basicAmount}</td>
                      <th style={styles.thLeft}>UAN NO</th>
                      <td style={styles.tdRight}>
                        {payslips?.employee?.uanNumber}
                      </td>
                    </tr>
                    <tr>
                      <th style={styles.thLeft}>DA</th>
                      <td style={styles.tdRight}>{payslips?.daAmount}</td>
                      <th style={styles.thLeft}>ESIC NO</th>
                      <td style={styles.tdRight}>
                        {payslips?.employee?.esicNumber}
                      </td>
                    </tr>
                    <tr>
                      <th style={styles.thLeft}>HRA</th>
                      <td style={styles.tdRight}>
                        {payslips?.attendanceAllowance}
                      </td>
                      <th style={styles.thLeft}>DOJ</th>
                      <td style={styles.tdRight}>
                        {moment(payslips?.employee?.dateOfJoining).format(
                          "DD-MM-YYYY"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th style={styles.thLeft}>MONTH</th>
                      <td style={styles.tdRight}>{`${
                        monthNames[(payslips?.month || 1) - 1]
                      },${payslips?.year}`}</td>
                      <th style={styles.thLeft}>
                        NUMBER OF DAYS EMPLOYEE WORKED
                      </th>
                      <td style={styles.tdRight}>{payslips?.salaryDays}</td>
                    </tr>
                    <tr>
                      <th style={styles.thLeft}>TOTAL COMPANY WORKING DAYS</th>
                      <td style={styles.tdRight}>{payslips?.monthDays}</td>
                      <th style={styles.thLeft}>
                        NUMBER OF DAYS EMPLOYEE ABSENT
                      </th>
                      <td style={styles.tdRight}>{payslips?.absentDays}</td>
                    </tr>
                  </tbody>
                </table>
                {/* Earnings and Deductions Table */}
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.thCenter} colSpan="2">
                        EARNINGS
                      </th>
                      <th style={styles.thCenter} colSpan="2">
                        DEDUCTIONS
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={styles.tdLeft}>EARNED BASIC</td>
                      <td style={styles.tdRight}>{payslips?.earnedBasic}</td>
                      <td style={styles.tdLeft}>ESIC</td>
                      <td style={styles.tdRight}>{payslips?.esiAmount}</td>
                    </tr>
                    <tr>
                      <td style={styles.tdLeft}>EARNED DA</td>
                      <td style={styles.tdRight}>{payslips?.earnedDa}</td>
                      <td style={styles.tdLeft}>PF</td>
                      <td style={styles.tdRight}>{payslips?.pfAmount}</td>
                    </tr>
                    <tr>
                      <td style={styles.tdLeft}>EARNED HRA</td>
                      <td style={styles.tdRight}>
                        {payslips?.attendanceAllowance}
                      </td>
                      <td style={styles.tdLeft}>ADVANCE</td>
                      <td style={styles.tdRight}>{payslips?.advanceAmount}</td>
                    </tr>
                    <tr>
                      <td style={styles.tdLeft}>EARNED CONVEYANCE</td>
                      <td style={styles.tdRight}>{payslips?.otAmount}</td>
                      <td style={styles.tdLeft}>MEALS</td>
                      <td style={styles.tdRight}>{payslips?.mealsAmount}</td>
                    </tr>
                    <tr>
                      <td style={styles.tdLeft}>ADDITIONAL ALLOWANCE</td>
                      <td style={styles.tdRight}>
                        {payslips?.shiftPaiseAmount}
                      </td>
                      <td style={styles.tdLeft}>DEDUCTIONS TOTAL</td>
                      <td style={styles.tdRight}>
                        {+payslips?.esiAmount +
                          +payslips?.pfAmount +
                          +payslips?.advanceAmount +
                          +payslips?.mealsAmount}
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.tdLeft}>EARNED INCENTIVE</td>
                      <td style={styles.tdRight}>{payslips?.busFare}</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td style={styles.tdLeft}>OVERTIME</td>
                      <td style={styles.tdRight}>{payslips?.otAmount}</td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <th style={styles.thLeft}>GROSS PAY</th>
                      <td style={styles.tdRight}>{payslips?.grossPay}</td>
                      <th style={styles.thLeft}>NET PAY (GROSS - DEDU)</th>
                      <td style={styles.tdRight}>{payslips?.netPay}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            );
          })
        )}
      </Card>
    </DashboardLayout>
  );
};

export default SalarySlip;
